import { ApiFactory } from "@collapick/utils/dist/ApiFactory";
import { useUserContext } from "../context/UserContext";

const useApi = () => {
    const userContext = useUserContext();
    return ApiFactory(userContext.token, null, true, true)
};

export default useApi;